<template>
  <div class="h-screen flex overflow-hidden bg-cool-gray-100">
    <div class="flex lg:flex-shrink-0 w-full min-w-full">
      <div class="flex flex-col w-full min-w-full">
        <div
          class="flex flex-col flex-grow bg-gray-800 pt-5
          pb-4 overflow-y-auto w-full min-w-full"
        >
          <div class="flex items-center flex-shrink-0 px-4">
            <img
              class="h-8 w-auto"
              src="/img/TeeWizLogoAlt.png"
              alt="TeeWiz logo"
            >
          </div>

          <div
            v-if="hasClubs"
            class="bg-gray-700 hover:bg-gray-600 select-none
            cursor-pointer rounded-lg mx-2 mt-8 p-2 pl-3 text-sm
            text-gray-200 flex justify-between items-center"
            @click="openClubDropdown = !openClubDropdown"
          >
            <div
              v-if="selectedClub !== null"
              class="text-sm leading-6 font-medium text-white"
            >
              {{ selectedClub.name }}
            </div>
            <div
              class="leading-none mr-1"
              style="margin-top: 2px;"
            >
              <i
                v-if="!openClubDropdown"
                class="fas fa-chevron-down"
              />
              <i
                v-if="openClubDropdown"
                class="fas fa-chevron-up"
              />
            </div>
          </div>

          <div
            v-if="hasClubs"
            class="transition-all duration-300"
            :class="openClubDropdown ? 'max-h-96 overflow-y-scroll' : 'h-0 overflow-hidden'"
          >
            <div
              v-for="club in filteredClubs"
              :key="club.id"
              class="bg-gray-900 hover:bg-gray-700
              select-none cursor-pointer rounded-lg mx-2 mt-2
              p-2 pl-3 text-sm text-gray-200 flex justify-between
              items-center"
              @click="setClub(club)"
            >
              <div
                class="text-sm leading-6 font-medium
              text-white"
              >
                {{ club.name }}
              </div>
            </div>

            <router-link to="/Club?NewClub=true">
              <div
                class="bg-gray-900 hover:bg-gray-700
                select-none cursor-pointer rounded-lg mx-2 mt-2 p-2 pl-3 text-sm text-gray-200 flex items-center"
                @click="openClubDropdown = false"
              >
                <div style="margin-bottom: 1px;">
                  <i class="fal fa-plus mr-2 " />
                </div>
                <div
                  class="text-sm leading-6 font-medium
                text-white"
                >
                  Add a new club
                </div>
              </div>
            </router-link>
          </div>

          <router-link
            v-if="!hasClubs"
            to="/Club?NewClub=true"
          >
            <div
              class="bg-gray-700 hover:bg-gray-600
              select-none cursor-pointer rounded-lg mx-2 mt-8 p-2 pl-3 text-sm text-gray-200 flex items-center"
            >
              <div style="margin-bottom: 1px;">
                <i class="fal fa-plus mr-2 " />
              </div>
              <div
                class="text-sm leading-6 font-medium
              text-white"
              >
                Add a new club
              </div>
            </div>
          </router-link>


          <hr class="h-px mt-4 bg-gray-700 border-none">

          <div class="mt-3 flex-1 flex flex-col overflow-y-auto select-none">
            <div class="overflow-y-auto">
              <nav class="px-2 space-y-1">
                <router-link to="/">
                  <div
                    :class="view === ''? 'bg-gray-700 text-white hover:bg-gray-600  focus:bg-gray-600' : 'text-gray-100 hover:text-white hover:bg-gray-600 focus:bg-gray-500'"
                    class="group cursor-pointer flex items-center px-2
                    py-2 text-sm leading-6 font-medium rounded-md
                    transition focus:outline-none ease-in-out
                    duration-150"
                  >
                    <i
                      style="margin-top: 1px; width: 2rem;"
                      class="fal fa-home text-lg leading-none ml-1
                      text-gray-200 group-hover:text-gray-200
                      group-focus:text-gray-200 transition ease-in-out
                      duration-150"
                    />
                    Home
                  </div>
                </router-link>

                <!-- <router-link to="/Club">
                  <div
                    :class="view === 'Club'? 'bg-gray-700 text-white hover:bg-gray-600  focus:bg-gray-600' : 'text-gray-100 hover:text-white hover:bg-gray-600 focus:bg-gray-500'"
                    class="group cursor-pointer flex items-center
                    px-2 py-2 my-2 text-sm leading-6 font-medium rounded-md
                    focus:outline-none  transition ease-in-out duration-150"
                  >
                    <i
                      style="margin-top: 1px; width: 2rem;"
                      class="fal fa-golf-club text-lg leading-none ml-1
                      text-gray-200 group-hover:text-gray-200
                      group-focus:text-gray-200 transition
                      ease-in-out duration-150"
                    />
                    Club
                  </div>
                </router-link> -->

                <router-link to="/Courses">
                  <div
                    :class="view === 'Courses'? 'bg-gray-700 text-white hover:bg-gray-600  focus:bg-gray-600' : 'text-gray-100 hover:text-white hover:bg-gray-600 focus:bg-gray-500'"
                    class="group cursor-pointer flex items-center px-2
                    py-2 my-2 text-sm leading-6 font-medium rounded-md
                    focus:outline-none  transition ease-in-out duration-150"
                  >
                    <i
                      style="margin-top: 1px; width: 2rem;"
                      class="fal fa-flag-alt text-lg leading-none ml-1
                      text-gray-200 group-hover:text-gray-200
                      group-focus:text-gray-200 transition ease-in-out
                      duration-150"
                    />
                    Courses
                  </div>
                </router-link>

                <router-link to="/TeeSheet">
                  <div
                    :class="view === 'TeeSheet'? 'bg-gray-700 text-white hover:bg-gray-600 focus:bg-gray-600':'text-gray-100 hover:text-white hover:bg-gray-600 focus:bg-gray-500'"
                    class="group cursor-pointer flex items-center px-2
                    py-2 my-2 text-sm leading-6 font-medium rounded-md
                    focus:outline-none  transition ease-in-out
                    duration-150"
                  >
                    <i
                      style="margin-top: 1px; width: 2rem;"
                      class="fal fa-th text-lg leading-none ml-1 text-gray-200
                      group-hover:text-gray-200 group-focus:text-gray-200 transition ease-in-out duration-150"
                    />
                    Tee Sheet
                  </div>
                </router-link>

                <!-- <router-link to="/Events">
                  <div
                    :class="view === 'Events'? 'bg-gray-700 text-white hover:bg-gray-600  focus:bg-gray-600':'text-gray-100 hover:text-white hover:bg-gray-600 focus:bg-gray-500'"
                    class="group cursor-pointer flex items-center px-2
                    py-2 my-2 text-sm leading-6 font-medium rounded-md
                    focus:outline-none transition ease-in-out duration-150"
                  >
                    <i
                      style="margin-top: 1px; width: 2rem;"
                      class="fal fa-calendar-day text-lg leading-none ml-1 text-gray-200 group-hover:text-gray-200 group-focus:text-gray-200 transition ease-in-out duration-150"
                    />
                    Events
                  </div>
                </router-link> -->

                <!-- <router-link
                  to="/Contacts"
                  class="p-0 m-0 leading-none"
                >
                  <div
                    :class="view === 'Contacts'? 'bg-gray-700 text-white hover:bg-gray-600  focus:bg-gray-600':'text-gray-100 hover:text-white hover:bg-gray-600 focus:bg-gray-500'"
                    class="group cursor-pointer flex items-center px-2
                    py-2 my-2 text-sm leading-6 font-medium rounded-md
                    focus:outline-none  transition ease-in-out duration-150"
                  >
                    <i
                      style="margin-top: 1px; width: 2rem;"
                      class="fal fa-address-book text-lg leading-none ml-1
                      text-gray-200 group-hover:text-gray-200
                      group-focus:text-gray-200 transition ease-in-out
                      duration-150"
                    />
                    Players
                  </div>
                </router-link> -->
              </nav>
            </div>

            <hr class="h-px mt-2 bg-gray-700 border-none">

            <div class="mt-2 flex-1 h-0 overflow-y-auto">
              <nav class="px-2 space-y-1">
                <!-- <router-link to="/Settings">
                  <div
                    :class="view === 'Settings'? 'bg-gray-700 text-white hover:bg-gray-600focus:bg-gray-600' : 'text-gray-100 hover:text-white hover:bg-gray-600 focus:bg-gray-500'"
                    class="group cursor-pointer flex items-center
                    px-2 py-2 my-2 text-sm leading-6 font-medium
                    rounded-md  focus:outline-none transition
                    ease-in-out duration-150"
                  >
                    <i
                      style="margin-top: 1px; width: 2rem;"
                      class="fal fa-cog text-lg leading-none ml-1
                      text-gray-200 group-hover:text-gray-200
                      group-focus:text-gray-200 transition
                      ease-in-out duration-150"
                    />
                    Settings
                  </div>
                </router-link>

                <router-link to="/Help">
                  <div
                    :class="view === 'Help' ? 'bg-gray-700 text-white hover:bg-gray-600  focus:bg-gray-600':'text-gray-100 hover:text-white hover:bg-gray-600 focus:bg-gray-500'"
                    class="group cursor-pointer flex items-center px-2
                    py-2 my-2 text-sm leading-6 font-medium rounded-md
                    focus:outline-none transition ease-in-out duration-150"
                  >
                    <i
                      style="margin-top: 1px; width: 2rem;"
                      class="fal fa-question-circle text-lg leading-none ml-1
                      text-gray-200 group-hover:text-gray-200
                      group-focus:text-gray-200 transition
                      ease-in-out duration-150"
                    />
                    Help
                  </div>
                </router-link> -->
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {

  name: 'Sidebar',

  data() {
    return {
      openClubDropdown: false,
    };
  },

  computed: {
    ...mapState({
      selectedClub: state => state.club.selectedClub,
      availableClubs: state => state.club.availableClubs,
      tenantId: state => state.user.tenantId,
    }),

    filteredClubs() {
      if (this.selectedClub !== null) {
        return this.availableClubs.filter(c => c.id !== this.selectedClub.id);
      }
      return [];
    },

    hasClubs() {
      return this.availableClubs && this.availableClubs.length > 0;
    },

    view() {
      return this.$route.name;
    },
  },

  methods: {
    setClub(club) {
      this.$store.dispatch('setSelectedClub', club);
      this.openClubDropdown = false;
    },

    // getDropdownStyle() {
    //   if (this.openClubDropdown) {
    //     return `height: ${48 * (this.filteredClubs.length + 1)}px`;
    //   }
    //   return 'height: 0';
    // },
  },

};
</script>

<style>
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background-color: #999;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}
</style>
